import React, { useState } from 'react';

import Modal from './modal';
import { Button } from 'components/ui/button';

export default function ShadowCreationButton() {
  const [showModal, setShowModal] = useState();

  return <React.Fragment>
    <Button onClick={() => setShowModal(true)}>
      New Grid
    </Button>

    {showModal && <Modal show onClose={() => setShowModal(false)} />}
  </React.Fragment>;
}
